import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Constants
import { INFO_NAVIGATION_LIST } from "constants/navigation/info";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

const InfoSidebar = () => {
  const t = useTranslate();

  const InfoSidebarClass = classNames(
    "InfoSidebar__link",
    "InfoSidebar__link_active",
  );

  return (
    <div className="InfoSidebar">
      {INFO_NAVIGATION_LIST.map((item) => (
        <NavLink
          to={makeLangUrl(item.link)}
          key={item.name}
          className={({ isActive }) =>
            isActive ? InfoSidebarClass : "InfoSidebar__link"
          }
          end
        >
          {t(item.name)}
        </NavLink>
      ))}
    </div>
  );
};

export default InfoSidebar;
